import InfosCarrier from './InfosCarrier';
import Nav from './Nav';
import Image from './Image';
import Description from './Description';
export default function Header() {
    return (
        <>
            <Nav />
            <div className='header'>
                <Description />
                <InfosCarrier />
            </div>
        </>
    );
}